import React from 'react';

export default function Welcome({ tokenData, onStart }) {
  return (
    <div style={{
      minHeight:'100vh', display:'flex', flexDirection:'column',
      background:'#0a0a0a', fontFamily:'system-ui', padding:32,
    }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:48 }}>
        <div style={{ width:8, height:8, borderRadius:'50%', background:'#4ade80' }}/>
        <span style={{ color:'#fff', fontWeight:600, fontSize:14 }}>Cerebro Risk</span>
        <span style={{ color:'#444', fontSize:12 }}>· Virtual Risk Engineering</span>
      </div>

      <div style={{ flex:1, display:'flex', flexDirection:'column', justifyContent:'center', maxWidth:480 }}>
        <div style={{ fontSize:12, color:'#4ade80', letterSpacing:'0.1em', textTransform:'uppercase', marginBottom:16 }}>
          Property Risk Assessment
        </div>
        <div style={{ fontSize:28, fontWeight:600, color:'#fff', lineHeight:1.3, marginBottom:12 }}>
          {tokenData.insured_name || 'Your Property'}
        </div>
        <div style={{ fontSize:14, color:'#666', marginBottom:32, lineHeight:1.6 }}>
          This self-guided assessment takes approximately 10–15 minutes to complete.
          You'll be asked questions about your property and prompted to take a few photos.
        </div>

        <div style={{ background:'#141414', border:'1px solid #222', borderRadius:8, padding:20, marginBottom:32 }}>
          <div style={{ fontSize:11, color:'#444', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:14 }}>
            What to expect
          </div>
          {[
            ['📋', 'Questions about construction, protection, and operations'],
            ['📸', 'Photos of key areas — electrical panel, sprinkler riser, storage'],
            ['✅', 'Submit when complete — your broker will be notified'],
          ].map(([icon, text]) => (
            <div key={text} style={{ display:'flex', gap:12, alignItems:'flex-start', marginBottom:10 }}>
              <span style={{ fontSize:16 }}>{icon}</span>
              <span style={{ fontSize:13, color:'#999', lineHeight:1.5 }}>{text}</span>
            </div>
          ))}
        </div>

        <button
          onClick={onStart}
          style={{
            width:'100%', height:52, borderRadius:8,
            background:'#4ade80', border:'none', color:'#000',
            fontSize:15, fontWeight:700, cursor:'pointer',
            letterSpacing:'0.02em',
          }}
        >
          Start Assessment →
        </button>

        <div style={{ fontSize:11, color:'#333', textAlign:'center', marginTop:16 }}>
          Your responses are encrypted and used only for risk engineering purposes.
        </div>
      </div>
    </div>
  );
}
